// context/PermissionContext.js
import { createContext, useContext, useState } from 'react';
import ajaxUser from '../util/remote/ajaxUser';

const PermissionContext = createContext();

export const PermissionProvider = ({ children }) => {
  const [permissions, setPermissions] = useState([]);
  const [role, setRole] = useState(null);
  const [configRole, setConfigRole] = useState(null);
  const [accessAllocation, setAccessAllocation] = useState({show: false, permissions: null, callback: null});
  const [rolePermissions, setRolePermissions] = useState(null);
  const [accessRevoke, setAccessRevoke] = useState({show: false, role: null, callback: null});

  const loadPermissions = async () => {
    const response = await ajaxUser.fetchPermissions();
    if (response.status === 'OK') {
        setPermissions(response.details);
        setRole(response.role);
    }else {
        setPermissions('404');
    }
  };

  const getRolePermissions = async (roleId) => {
    const server_response = await ajaxUser.fetchRolePermissions(roleId);
    if (server_response.status === 'OK') {
      setRolePermissions(server_response.details);
    } else {
      setRolePermissions('404');
    }
  }

  const hasPermission = (key) => permissions.includes(key);

  return (
    <PermissionContext.Provider value={{
         permissions, 
         role,
         accessAllocation,
         rolePermissions,
         configRole,
         accessRevoke,
         loadPermissions, 
         hasPermission,
         setAccessAllocation,
         getRolePermissions,
         setConfigRole,
         setAccessRevoke,
         }}>
      {children}
    </PermissionContext.Provider>
  );
};

export const usePermission = () => useContext(PermissionContext);
